import { Component } from '@angular/core';

@Component({
  selector: 'app-pharmacy-snack-icon',
  imports: [],
  templateUrl: './pharmacy-snack-icon.html',
  styleUrl: './pharmacy-snack-icon.scss',
})
export class PharmacySnackIcon {

}
